import {ChangeDetectorRef, Component, HostBinding, OnDestroy} from "@angular/core";
import {FUINavigationService} from "../../navigation/navigation.service";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-canvas-overlay",
    styleUrls: ["./canvas-overlay.component.scss"],
    templateUrl: "./canvas-overlay.component.html"
})
export class FUICanvasOverlayComponent implements OnDestroy {
    @HostBinding("class.active") public active: boolean;

    private subscriptions: Subscription = new Subscription();

    constructor(private navigationService: FUINavigationService, private changeDetectorRef: ChangeDetectorRef) {
        this.subscriptions.add(this.navigationService.activeModal$.subscribe(
            (active) => {
                this.active = active;
                this.changeDetectorRef.markForCheck();
            }
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
